// ─── Configuration finance de l'espace : accès Firestore ──────────
// UN document par espace — `configFinance/{espaceId}` — pour les catégories
// personnalisées, les masquages et les sous-catégories (Cédric, 15/08).
// Les RÈGLES vivent dans `services/categoriesPerso.js`, module pur et testé ;
// ici on ne fait que lire et écrire.
//
// Un seul document et non une collection de catégories : c'est de la
// configuration à faible volume — une écoute unique, un ordre trivial, et un
// `merge` qui n'écrase jamais ce qu'un autre membre vient de poser.
import { db } from '@mop/core';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { CONFIG_DEFAUT } from './categoriesPerso.js';

export function ecouterConfigFinance(espaceId, callback, onErreur) {
  if (!espaceId) { callback(CONFIG_DEFAUT); return () => {}; }
  return onSnapshot(doc(db, 'configFinance', espaceId), (snap) => {
    // Document absent = config par défaut : on ne crée RIEN tant que
    // l'utilisateur n'a rien personnalisé.
    callback(snap.exists() ? { ...CONFIG_DEFAUT, ...snap.data() } : CONFIG_DEFAUT);
  }, (e) => { callback(CONFIG_DEFAUT); onErreur?.(e); });
}

// `patch` ne porte que les champs modifiés : le `merge` préserve le reste.
export async function sauverConfigFinance(espaceId, patch, majPar) {
  if (!espaceId) throw new Error('configFinance.espace');
  await setDoc(doc(db, 'configFinance', espaceId), {
    espaceId, ...patch, majPar: majPar || null, majLe: new Date().toISOString(),
  }, { merge: true });
}
